import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import { FONT_INTER } from "../../../styles/fonts";

const ACCENT_COLOR = "#185CFB";

// MUI Dialog wrapper for a yes/no confirmation step before an irreversible action
// (e.g. removing a resource↔profile association).
const ConfirmDialog = ({
  open,
  title,
  text,
  confirmLabel = "Confirmar",
  cancelLabel = "Cancelar",
  onConfirm,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={onCancel}
    PaperProps={{ sx: { fontFamily: FONT_INTER, borderRadius: "8px" } }}
  >
    <DialogTitle sx={{ fontFamily: FONT_INTER, fontWeight: 600 }}>
      {title}
    </DialogTitle>

    <DialogContent>
      <DialogContentText sx={{ fontFamily: FONT_INTER, color: "#1a1a2e" }}>
        {text}
      </DialogContentText>
    </DialogContent>

    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onCancel} sx={{ fontFamily: FONT_INTER, textTransform: "none" }}>
        {cancelLabel}
      </Button>
      <Button
        onClick={onConfirm}
        variant="contained"
        sx={{
          fontFamily: FONT_INTER,
          textTransform: "none",
          backgroundColor: ACCENT_COLOR,
          "&:hover": { backgroundColor: "#124bcf" },
        }}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
